export default "__VITE_ASSET__DB32cvn___"